import React from 'react';
import queryString from 'query-string';

import AuthContainer from '../../modules/auth/containers/Auth';
import withUnAuth from './withUnAuth';

import CreateAccountForm from '../Forms/Auth/CreateAccount';

const CreateAccountPage = ({ location: { search } }) => {
  const query = queryString.parse(search);

  return (
    <div className="ResetPasswordPage">
      <CreateAccountForm token={query.token} />
    </div>
  );
};

export default withUnAuth(AuthContainer(CreateAccountPage));
